// extracted by mini-css-extract-plugin
export default {"container":"priceBadge-module__container__5t7Tj","price":"priceBadge-module__price__4ZAmH","tooltip":"priceBadge-module__tooltip__fGrnn"};